// Shared bits for the Help Centre (components/help/*, pages/super/Help*.jsx).
// Articles live in helpArticles/{id} — see functions/helpCenter.js for how
// the chatbot answers from them.

// Order here is the order categories are shown in Browse.
export const HELP_CATEGORIES = [
  { key: 'gettingStarted', label: 'Getting started' },
  { key: 'crm', label: 'CRM & leads' },
  { key: 'onboarding', label: 'Onboarding & players' },
  { key: 'contracts', label: 'Contracts' },
  { key: 'finance', label: 'Quotes & invoices' },
  { key: 'email', label: 'Email & automation' },
  { key: 'calendar', label: 'Calendar, bookings & visits' },
  { key: 'settings', label: 'Settings & team' },
  { key: 'academyPortal', label: 'Academy Portal' },
  { key: 'agency', label: 'Agencies & partners' },
];

export const HELP_AUDIENCES = [
  { key: 'all', label: 'Academies and agencies' },
  { key: 'academy', label: 'Academies only' },
  { key: 'agency', label: 'Agencies only' },
];

// An article field is { en, es }; Spanish falls back to English until it's
// been translated.
export function pickLang(field, lang) {
  if (!field) return '';
  if (typeof field === 'string') return field;
  return (lang === 'es' && field.es) || field.en || '';
}

export function articleAppliesTo(article, isAgencyTenant) {
  const audience = article.audience || 'all';
  return audience === 'all' || audience === (isAgencyTenant ? 'agency' : 'academy');
}

// Which portal the user is in, for the chatbot's context. Shared pages
// (Settings, Contracts, …) don't say, so fall back to the mode the sidebar
// last remembered (Sidebar.jsx's portalMode key).
export function currentPortal(pathname, uid) {
  if (pathname.startsWith('/admin/crm')) return 'crm';
  try {
    const stored = localStorage.getItem(`portalMode:${uid}`);
    if (stored === 'crm' || stored === 'onboarding') return stored;
  } catch { /* ignore */ }
  return pathname.startsWith('/admin') ? 'onboarding' : null;
}

export function searchArticles(articles, term, lang) {
  const words = term.toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return articles;
  return articles
    .map((a) => {
      const title = pickLang(a.title, lang).toLowerCase();
      const hay = `${title} ${pickLang(a.summary, lang)} ${(a.keywords || []).join(' ')} ${pickLang(a.body, lang)}`.toLowerCase();
      if (!words.every((w) => hay.includes(w))) return null;
      return { a, score: words.filter((w) => title.includes(w)).length };
    })
    .filter(Boolean)
    .sort((x, y) => y.score - x.score)
    .map((x) => x.a);
}
